/**
 * License Management Module API Reference:
 * - Dashboard: /license/dashboard.read
 * - Service Status: /license/service/status.read
 * - Subscriptions: /license/subscriptions.read, .update
 * - History: /license/history.read
 * - Import: /license/add.create
 * - Sites/Devices: /sites.read, /devices.read
 */

import React, { useState } from "react";
import {
  useOutletContext,
} from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { FormattedMessage } from "react-intl";

import mainStyle from "./mainStyle.module.scss";

// components
import Overview from "./Overview";
import Subscriptions from "./Subscriptions";
import Transactions from "./Transactions";
import UsageEmulator from "./UsageEmulator";

// assets
import btn_overview from "assets/images/icons/btn_overview.png";
import btn_subscriptions from "assets/images/icons/btn_subscriptions.png";
import btn_transactions from "assets/images/icons/btn_transactions.png";
import btn_usage_emulator from "assets/images/icons/btn_emulator.png";

const LicenseManagement = () => {
  const context = useOutletContext();
  const theme = useTheme();

  const [nowAnchor, setNowAnchor] = useState("overview");

  const menuItems = [
    {
      id: "overview",
      title: "overview",
      icon: btn_overview,
      lightIcon: btn_overview,
    },
    {
      id: "subscriptions",
      title: "subscriptions",
      icon: btn_subscriptions,
      lightIcon: btn_subscriptions,
    },
    {
      id: "transactions",
      title: "transactions",
      icon: btn_transactions,
      lightIcon: btn_transactions,
    },
    {
      id: "usage-emulator",
      title: "usage-emulator",
      icon: btn_usage_emulator,
      lightIcon: btn_usage_emulator,
    },
  ];

  const handleNavigate = (id) => {
    setNowAnchor(id);
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", height: "100%", gap: 2 }}
    >
      <div className={mainStyle["mainArea"]}>
        <div className={mainStyle["anchorArea"]}>
          <div className={mainStyle["anchorBody"]}>
            {menuItems.map((item) => {
              const isSelected = nowAnchor === item.id;
              // Check if icon is the specifically named "light" version
              const isSourceLight = item.icon.includes("light");

              return (
                <Box key={item.id} onClick={() => handleNavigate(item.id)}>
                  <div
                    className={mainStyle["anchorItem"]}
                    style={{
                      backgroundColor: isSelected
                        ? theme.palette.primary.main
                        : "",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.id}
                      style={{
                        width: "40px",
                        // If selected and source is dark -> make it white
                        // If not selected and source is light -> make it dark
                        filter: isSelected
                          ? !isSourceLight
                            ? "brightness(0) invert(1)"
                            : "none"
                          : isSourceLight
                            ? "brightness(0)"
                            : "none",
                      }}
                    />
                    <span
                      className={mainStyle["anchorItem_text"]}
                      style={{
                        color: isSelected
                          ? theme.palette.common.white
                          : theme.palette.primary.main,
                      }}
                    >
                      <FormattedMessage
                        id={
                          item.id === "usage-emulator"
                            ? "usage-emulator"
                            : item.title
                        }
                      />
                    </span>
                  </div>
                </Box>
              );
            })}
          </div>
        </div>
        <div className={mainStyle["userArea"]}>
          <div className={mainStyle["contentArea"]}>
            {nowAnchor === "overview" && (
              <Overview context={context} onTabChange={setNowAnchor} />
            )}
            {nowAnchor === "subscriptions" && (
              <Subscriptions context={context} onTabChange={setNowAnchor} />
            )}
            {nowAnchor === "transactions" && (
              <Transactions context={context} onTabChange={setNowAnchor} />
            )}
            {nowAnchor === "usage-emulator" && (
              <UsageEmulator context={context} onTabChange={setNowAnchor} />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default LicenseManagement;
